import { takeEvery, fork, all, takeLatest } from 'redux-saga/effects';
import {
    GET_DROPDOWN,
    GET_PRODUCTS,
    GET_PRODUCTS_BULK,
    // GET_PRODUCTSGUIDE,
    VALIDATE_PRODUCTS,
    GET_PRODUCT_DETAILS,
    GET_SHIPPING_METHODS,
    GET_SHIP_TO_ADDRESS,
    GET_BATCH_ALLOCATIONS,
    SAVE_SURGERY_DETAILS,
    GET_SURGERY_DETAILS,
    UPDATE_SURGERY_DETAILS,
    GET_PRODUCT_BRAND_AND_CATEGORY_DATA,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
    PUT_RECENTLY_USED_PHYSICIANS,
    GET_DERIVED_TERRITORIES,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST,
    CREATE_PRODUCT_TEMPLATE,
    GET_TEMPLATE_DETAILS,
    GET_HOLIDAY_LIST,
    UPDATE_PRODUCT_TEMPLATE,
    GET_DATA_FOR_PRODUCT_TEMPLATE,
    UPDATE_PRODUCT_TEMPLATE_LIST,
    CHECK_DUPLICATE_TEMPLATE,
    updateDetailedProductTemplateList,
    VALIDATE_ACCOUNT,
    GET_SCHEDULE_SURGERY_DETAILS,
    GET_IMAGE_PO_PREVIEW,
    SURGERY_DELETE_ATTACHMENT_REQUEST,
    SURGERY_ATTACHMENT_UPLOAD,
    VALIDATE_BILLTO,
} from '../actions';
import searchProducts from './productsSearchSaga';
import searchProductsBulk from './productsSearchBulkSaga';
import getDropDownSaga from './getDropDownSaga';
// import getProductGuideSaga from './productsGuideSaga';
import validateProductsSaga from './validateProductsSaga';
//import productsTemplatesFilterSaga from './productsTemplatesFilterSaga';
import getShippingMethodsSaga from './shippingMethodsSaga';
import getShipToAddressSaga from './shipToAddressSaga';
import getShippingBatchAllocationsSaga from './shippingBatchAllocationsSaga';
import getProductDetailsSaga from './productDetailsSaga';
import saveSurgery from './createSurgerySaga';
import updateSurgerySaga from './updateSurgerySaga';
import getCategoryAndBrands from './getCategoryAndBrandsSaga';
import getProductsByBrandOrSuperCategory from './getProductsByBrandOrSuperCategorySaga';
import putRecentlyUsedPhysicians from './putRecentlyUsedPhysicianSaga';
import getDerivedTerritories from './derivedTerritorySaga';
import {
    createProductTemplate,
    getDetailedProductTemplates,
    getTemplateDetails,
    updateProductTemplate,
    getDataForTemplate,
    checkDuplicatetemplate,
} from './productTemplateSaga';
import getHolidayList from './getHolidaysListSaga';
import validateAccountSaga from './validateAccountSaga';
import validateBillToSaga from './validateBillToSaga';
import {
    deleteAttachmentSaga,
    getImagePoPreviewSaga,
    getScheduleSurgeryDetailsSaga,
    getSurgeryDetails,
    usageAttachmentUploadSaga,
} from './surgeryDetailsSaga';
import { CHECK_PRODUCT_BOM, GET_TRANSFER_RECIPIENT_METHODS } from '../actions/actionTypes';
import productBom from './checkProductBomSaga';
import getTransferRecipient from './transferRecipientSaga';
// import { GET_SURGERY_DETAILS_SUCCESS } from 'src/pages/equity/redux/actions';

function* watchGetDropDownSaga() {
    yield takeEvery(GET_DROPDOWN, getDropDownSaga);
}

function* watchGetProductsSaga() {
    yield takeEvery(GET_PRODUCTS, searchProducts);
}

function* watchGetProductsBulkSaga() {
    yield takeEvery(GET_PRODUCTS_BULK, searchProductsBulk);
}

// function* watchGetProductsGuideSaga() {
//     yield takeEvery(GET_PRODUCTSGUIDE, getProductGuideSaga);
// }

// function* watchGetProductsTemplatesFilterSaga() {
//     yield takeEvery(GET_PRODUCTSTEMPLATESFILTER, productsTemplatesFilterSaga);
// }

function* watchCheckDuplicateSaga() {
    yield takeEvery(CHECK_DUPLICATE_TEMPLATE, checkDuplicatetemplate);
}

function* watchValidateProductsSaga() {
    yield takeEvery(VALIDATE_PRODUCTS, validateProductsSaga);
}

function* watchGetProductDetailsSaga() {
    yield takeEvery(GET_PRODUCT_DETAILS, getProductDetailsSaga);
}

function* watchGetShipToAddressSaga() {
    yield takeEvery(GET_SHIP_TO_ADDRESS, getShipToAddressSaga);
}

function* watchGetShippingMethodsSaga() {
    yield takeEvery(GET_SHIPPING_METHODS, getShippingMethodsSaga);
}

function* watchGetShippingBatchLocationsSaga() {
    yield takeEvery(GET_BATCH_ALLOCATIONS, getShippingBatchAllocationsSaga);
}

function* watchSaveSurgerySaga() {
    yield takeLatest(SAVE_SURGERY_DETAILS, saveSurgery);
}

function* watchSurgeryDetailsSaga() {
    yield takeLatest(GET_SURGERY_DETAILS, getSurgeryDetails);
}
function* watchScheduleSurgeryDetailsSaga() {
    yield takeLatest(
        GET_SCHEDULE_SURGERY_DETAILS,
        getScheduleSurgeryDetailsSaga
    );
}
function* watchUpdateSurgerySaga() {
    yield takeLatest(UPDATE_SURGERY_DETAILS, updateSurgerySaga);
}

function* watchGetCategoryAndBrandsSaga() {
    yield takeLatest(GET_PRODUCT_BRAND_AND_CATEGORY_DATA, getCategoryAndBrands);
}

function* watchGetProductsByBrandOrSuperCategorySaga() {
    yield takeLatest(
        GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY,
        getProductsByBrandOrSuperCategory
    );
}
function* watchPutRecentlyUsedPhysicianSaga() {
    yield takeLatest(PUT_RECENTLY_USED_PHYSICIANS, putRecentlyUsedPhysicians);
}

function* watchGetDerivedTerritoriesSaga() {
    yield takeLatest(GET_DERIVED_TERRITORIES, getDerivedTerritories);
}

function* watchGetDetailedProductTemplatesSaga() {
    yield takeLatest(
        GET_DETAILED_PRODUCT_TEMPLATE_LIST,
        getDetailedProductTemplates
    );
}

function* watchUpdateDetailedProductTemplatesSaga() {
    yield takeLatest(
        UPDATE_PRODUCT_TEMPLATE_LIST,
        updateDetailedProductTemplateList
    );
}

function* watchGetProductTemplateDetailsSaga() {
    yield takeLatest(GET_TEMPLATE_DETAILS, getTemplateDetails);
}

function* watchCreateProductTemplateSaga() {
    yield takeLatest(CREATE_PRODUCT_TEMPLATE, createProductTemplate);
}

function* watchUpdateProductTemplateSaga() {
    yield takeLatest(UPDATE_PRODUCT_TEMPLATE, updateProductTemplate);
}

function* watchGetDataForProductTemplateSaga() {
    yield takeLatest(GET_DATA_FOR_PRODUCT_TEMPLATE, getDataForTemplate);
}

function* getHolidayListSaga() {
    yield takeLatest(GET_HOLIDAY_LIST, getHolidayList);
}

function* watchValidateAccountSaga() {
    yield takeLatest(VALIDATE_ACCOUNT, validateAccountSaga);
}

function* watchValidateBillToSaga() {
    yield takeLatest(VALIDATE_BILLTO, validateBillToSaga);
}

function* watchGetImagePOPreviewSaga() {
    yield takeLatest(GET_IMAGE_PO_PREVIEW, getImagePoPreviewSaga);
}
function* watchSurgeryDeleteAttcahmentSaga() {
    yield takeLatest(SURGERY_DELETE_ATTACHMENT_REQUEST, deleteAttachmentSaga);
}
function* watchSurgeryUploadAttcahmentSaga() {
    yield takeLatest(SURGERY_ATTACHMENT_UPLOAD, usageAttachmentUploadSaga);
}

function* watchcheckProductBomSaga() {
    yield takeLatest(CHECK_PRODUCT_BOM, productBom);
}

function* watchSurgeryTransferRecipientSaga() {
    yield takeEvery(GET_TRANSFER_RECIPIENT_METHODS, getTransferRecipient);
}

export default function* surgeryRootSaga() {
    yield all([
        fork(watchGetDropDownSaga),
        fork(watchCheckDuplicateSaga),
        //fork(watchGetProductsTemplatesFilterSaga),
        fork(watchGetProductsSaga),
        fork(watchGetProductsBulkSaga),
        fork(watchValidateProductsSaga),
        fork(watchGetProductDetailsSaga),
        fork(watchGetShippingMethodsSaga),
        fork(watchGetShipToAddressSaga),
        fork(watchGetShippingBatchLocationsSaga),
        fork(watchSaveSurgerySaga),
        fork(watchSurgeryDetailsSaga),
        fork(watchScheduleSurgeryDetailsSaga),
        fork(watchUpdateSurgerySaga),
        fork(watchGetCategoryAndBrandsSaga),
        fork(watchGetProductsByBrandOrSuperCategorySaga),
        fork(watchPutRecentlyUsedPhysicianSaga),
        fork(watchGetDerivedTerritoriesSaga),
        fork(watchGetDetailedProductTemplatesSaga),
        fork(watchCreateProductTemplateSaga),
        fork(watchGetProductTemplateDetailsSaga),
        fork(watchUpdateProductTemplateSaga),
        fork(getHolidayListSaga),
        fork(watchGetDataForProductTemplateSaga),
        fork(watchUpdateDetailedProductTemplatesSaga),
        fork(watchValidateAccountSaga),
        fork(watchValidateBillToSaga),
        fork(watchGetImagePOPreviewSaga),
        fork(watchSurgeryDeleteAttcahmentSaga),
        fork(watchSurgeryUploadAttcahmentSaga),
        fork(watchcheckProductBomSaga),
        fork(watchSurgeryTransferRecipientSaga)
    ]);
}
